import React from 'react';
import ReactDOM from 'react-dom/client';
import "./index.css"
import "@fortawesome/fontawesome-free/css/all.min.css";
import "./assets/styles/tailwind.css";
import reportWebVitals from './reportWebVitals';
import { BrowserRouter, Navigate, Route, Routes } from 'react-router-dom';
import Auth from './layouts/Auth';
import Admin from './layouts/Admin';
import Vendor from './layouts/Vendor';
import Finance from './layouts/Finance';
import { Toaster } from 'sonner';
import OrderLists from './layouts/OrderLists';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <>
      
      <BrowserRouter basename='/finance/app' future={{ v7_relativeSplatPath: true }}>      
        <Routes>
          <Route path="/admin/*" element={<Admin />} />
          <Route path="/finance/*" element={<Finance />} />
          <Route path="/vendor/*" element={<Vendor />} />
          <Route path="/auth/*" element={<Auth />} />
          <Route path="/reports" element={<OrderLists />} />
          <Route path="/" element={<Navigate to="/auth/login" />} />
        </Routes>
      </BrowserRouter>
    
    <Toaster position="top-right" duration={3000} richColors toastOptions={{
      style: { background: '#eae6f3', boxShadow: "1px 1px 8px 8px rgba(115, 92, 173, 0.12)", border: "1px solid rgb(115, 92, 173)" },
    }} />
  </>
);
reportWebVitals();
